<template>
  <div class="purification">

    <div class="timing" v-if="modeArray&&modeArray.length>0">
      <div v-for="model in modeArray" class="purification-mode">
        <div class="title">{{ model.name }}工作模式</div>
        <div class="action">
          <div class="clickable" v-for="(option,index) in options" v-bind:class="{'action-selected': getValue(model.dataId)==option.value}"
               @click="$emit('control',model.dataId,index)">● {{ option.name }}</div>
        </div>
        <div v-if="model.time">
          <div class="time-row clickable" @click="clickTimeOn(model)"><div class="title">加药时间</div> {{getValue(model.time.onDataId)}} 分钟</div>
          <div class="time-row clickable" @click="clickTimeOff(model)"><div class="title">回流时间</div> {{getValue(model.time.offDataId)}} 分钟</div>
          <div class="time-row">
            <span class="title">定时加药</span>
            <div class="time-set clickable" @click="clickStartTime(model)">{{getFormatTime(model.time.hourOnDataId, model.time.minuteOnDataId)}}</div>
            <div>-</div>
            <div class="time-set clickable" @click="clickEndTime(model)">{{getFormatTime(model.time.hourOffDataId, model.time.minuteOffDataId)}}</div>
          </div>
        </div>

      </div>
    </div>

    <TimeDialog ref="timeDialog"></TimeDialog>
    <InputDialog ref="inputDialog"></InputDialog>

  </div>
</template>

<script>
import InputDialog from "@/components/dialog/InputDialog";
import TimeDialog from "@/components/dialog/TimeDialog.vue";
export default {
  components: {TimeDialog, InputDialog},
  props: ["modeArray","valueMap"],
  methods:{
    getValue(key){
      return this.valueMap[key]
    },
    control(key,value){
      this.$emit("control",key,value)
    },
    clickTimeOn(model){
      let that = this
      this.$refs.inputDialog.show({
        title: "设定加药时间",
        value: that.getValue(model.time.onDataId),
        onOk(value) {
          let dataId = model.time.onDataId
          that.control(dataId, value)
        }
      })
    },
    clickTimeOff(model){
      let that = this
      this.$refs.inputDialog.show({
        title: "设定回流时间",
        value: that.getValue(model.time.offDataId),
        onOk(value) {
          let dataId = model.time.offDataId
          that.control(dataId, value)
        }
      })
    },
    clickStartTime(item){
      let that = this
      this.$refs.timeDialog.show({
        title:item.name + "-启动",
        hour: this.getValue(item.time.hourOnDataId),
        minute: this.getValue(item.time.minuteOnDataId),
        onOk:(hour,minute)=>{
          that.$emit("control",item.time.hourOnDataId,hour)
          that.$emit("control",item.time.minuteOnDataId,minute)
        }
      })
    },
    clickEndTime(item){
      let that = this
      this.$refs.timeDialog.show({
        title:item.name + "-停止",
        hour: this.getValue(item.time.hourOffDataId),
        minute: this.getValue(item.time.minuteOffDataId),
        onOk:(hour,minute)=>{
          that.$emit("control",item.time.hourOffDataId,hour)
          that.$emit("control",item.time.minuteOffDataId,minute)
        }
      })
    },
    getFormatTime(hourDataId, minuteDataId){
      let hour = this.getValue(hourDataId)||0
      let minute = this.getValue(minuteDataId)||0
      let hourStr = ("00"+hour).substr(-2)
      let minuteStr = ("00"+minute).substr(-2)
      return `${hourStr}:${minuteStr}`
    }
  },
  computed:{
    options(){
      if(this.modeArray[0].time){
        return [
          {
            name: "自动",
            value: 0
          },
          {
            name: "间断",
            value: 1
          },
          {
            name: "定时",
            value: 2
          },
          {
            name: "手动",
            value: 3
          }
        ]
      }else{
        return [
          {
            name: "自动",
            value: 0
          },
          {
            name: "手动",
            value: 1
          }
        ]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.purification {

  .timing{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2vw;
  }

  .purification-mode {
    align-items: center;
    background: #03417B;
    border-radius: 10px;
    overflow: hidden;

    .title {
      text-align: center;
      background: #063366;
      font-size: 1.2vw;
      padding: 0.2vw;
    }
    .action{
      display: grid;
      grid-template-columns: repeat(2,1fr);
      text-align: center;
      font-size: 1.2vw;
      grid-column-gap: 2vw;
      grid-row-gap: 1vw;
      padding: 1vw;
    }

    .action-selected{
      color: #0084FF;
    }

    .time-row{
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2vw;
      background: #063366;
      margin: 5px;
      padding: 10px 20px;
      border-radius: 10px;

      .title{
        margin-right: 10px;
        color: #999;
        font-size: 1vw;
      }

      .time-set{
        padding: 5px;
      }
    }
  }

}
</style>
